class LoginDrawer extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
        this.querySelector('#LoginDrawer-Overlay').addEventListener('click', this.close.bind(this));
        this.setHeaderLoginIconAccessibility();
        this.delegateClickEvents();
    }

    setHeaderLoginIconAccessibility() {
        const cartLink = document.querySelector('#login-icon-bubble');
        if (!cartLink) return;
        cartLink.setAttribute('role', 'button');
        cartLink.setAttribute('aria-haspopup', 'dialog');
        this.addClickAndKeydownListeners(cartLink);
    }

    delegateClickEvents() {
        document.addEventListener('click', (event) => {
            const trigger = this.findTriggerElement(event.target);
            if (trigger) {
                event.preventDefault();
                this.open(trigger);
            }
        });

        document.addEventListener('keydown', (event) => {
            if (event.code.toUpperCase() === 'SPACE') {
                const trigger = this.findTriggerElement(document.activeElement);
                if (trigger) {
                    event.preventDefault();
                    this.open(trigger);
                }
            }
        });

        const searchParams = new URLSearchParams(window.location.search);
        if (searchParams.get('logged-in') == 'false') {
            setTimeout(() => {
                this.classList.add('animate', 'active');
            });
            document.body.classList.add('overflow-hidden');
        }
    }

    findTriggerElement(element) {
        return element.closest('[data-trigger="login-sidebar"], #login-icon-bubble');
    }

    addClickAndKeydownListeners(element) {
        element.addEventListener('click', (event) => {
            event.preventDefault();
            this.open(element);
        });
    }

    open(triggeredBy) {
        if (triggeredBy) this.setActiveElement(triggeredBy);
        setTimeout(() => {
            this.classList.add('animate', 'active');
        });
        document.body.classList.add('overflow-hidden');
    }

    close() {
        this.classList.remove('active');
        document.body.classList.remove('overflow-hidden');
    }

    setActiveElement(element) {
        this.activeElement = element;
    }
}

customElements.define('login-drawer', LoginDrawer);
